import React from 'react';
import { Check, X } from 'lucide-react';
export function Upsell() {
  const comparison = [{
    sit: 'No sabés cuánto cobrar',
    sin: 'Seguís cobrando de más o de menos',
    con: 'Fórmula de pricing exacta para Argentina'
  }, {
    sit: 'Los alumnos te pagan por clase',
    sin: 'Ingreso variable, impredecible',
    con: 'Modelo de suscripción mensual funcionando'
  }, {
    sit: 'No sabés cómo subir el precio',
    sin: 'Miedo a perder alumnos',
    con: 'Script de aumento con 30 días de anticipación'
  }, {
    sit: 'Instagram no te trae alumnos',
    sin: 'Posteos sin estrategia',
    con: 'Calendario de 3 posteos semanales que convierten'
  }, {
    sit: 'Te preguntan precio y no cierran',
    sin: 'Perdés consultas por WhatsApp',
    con: 'Scripts listos para cerrar la inscripción'
  }, {
    sit: 'Tenés alumnos con lesiones',
    sin: 'Improvás o los perdés',
    con: 'Protocolos de adaptación para lumbar, rodilla y hombro'
  }];
  const includes = ['Mentalidad de negocio vs. mentalidad de empleado', 'Fórmula de pricing para Argentina con inflación', 'Modelo de suscripción mensual paso a paso', 'Sistema de 3 posteos semanales para llenar grupos', '6 scripts de WhatsApp para cerrar inscripciones', 'Protocolo anti clase de prueba gratis', 'Sistema de cobro sin morosidad', 'Adaptaciones técnicas para embarazo y adultos mayores', 'Protocolos para lumbar, rodilla y hombro', 'Plan de ruta para abrir tu propio espacio', 'Calculadora de rentabilidad mensual', 'Plan concreto de 90 días'];
  return <section className="py-20 px-4 bg-surface2 border-y border-zinc-800" data-id="element-291">
      <div className="max-w-4xl mx-auto" data-id="element-292">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 flex items-center justify-center gap-3" data-id="element-293">
          <span data-id="element-294">🕊️</span> ¿QUÉ AGREGA EL MÉTODO PROFE EMPRESARIO?
        </h2>

        <div className="overflow-x-auto mb-16" data-id="element-295">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-296">
            <thead data-id="element-297">
              <tr className="border-b border-zinc-800 text-sm" data-id="element-298">
                <th className="p-4 font-medium text-zinc-400 w-1/3" data-id="element-299">
                  Situación en el negocio
                </th>
                <th className="p-4 font-medium text-red-400 w-1/3 flex items-center gap-2" data-id="element-300">
                  <X className="w-4 h-4" data-id="element-301" /> Sin el Método
                </th>
                <th className="p-4 font-medium text-primary w-1/3" data-id="element-302">
                  <div className="flex items-center gap-2" data-id="element-303">
                    <Check className="w-4 h-4" data-id="element-304" /> Con el Método
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="text-sm" data-id="element-305">
              {comparison.map((row, i) => <tr key={i} className="border-b border-zinc-800/50" data-id="element-306">
                  <td className="p-4 font-medium text-white" data-id="element-307">{row.sit}</td>
                  <td className="p-4 text-zinc-400" data-id="element-308">{row.sin}</td>
                  <td className="p-4 text-primary font-medium bg-primary/5" data-id="element-309">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="bg-surface border border-zinc-800 rounded-2xl p-8" data-id="element-310">
          <h3 className="text-xl font-bold mb-6 flex items-center gap-2" data-id="element-311">
            <span className="text-primary" data-id="element-312">✅</span> EL MÉTODO PROFE EMPRESARIO
            INCLUYE:
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-313">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-314">
                <div className="mt-1 bg-primary/20 p-1 rounded-full shrink-0" data-id="element-315">
                  <Check className="w-3 h-3 text-primary" data-id="element-316" />
                </div>
                <span className="text-zinc-300 text-sm" data-id="element-317">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}